



















































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore,
} from "@root/lib/decorator";
import { moneyRegexp } from "@root/lib/regexps";
import ProductAttrSelect from "@/components/custom/productAttrSelect/index.vue";
import CustomImportButton from "@/components/custom/CustomImportButton.vue";
import CustomExportButton from "@/components/custom/CustomExportButton.vue";

const priceX = namespace("price");
const root = namespace("root");
const scan = namespace("scan");
@Component({
  components: {
    ProductAttrSelect,
    CustomImportButton,
    CustomExportButton,
  },
})
@pagination("getData", {
  pageSize: 50,
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class SetPrice extends Vue {
  @root.State ddCodes;

  @root.Action getSystemValue;
  @root.Action queryExcelExportFile;
  @root.Action downLoadExcelFile;
  @root.Action grantExportFileAccessUrl;
  @root.State mainRouter;

  @scan.Action getAttr;
  @scan.Action getPCRAttr;
  @scan.Action queryCustomerLevelList;

  @priceX.Action queryPremiumList;
  @priceX.Action queryK1PremiumPage;
  @priceX.Action downloadPremiumModel;
  @priceX.Action importK1Premium;
  @priceX.Action updateK1Premium;
  @priceX.Action exportK1Premium;

  private dataList = [];
  private specificationListOptions = [];
  private patternListOptions = [];
  private levelList = [];

  private form = {
    specifications: "",
    pattern: "",
    productCode: "",
    oeProducts: []
  };
  private levelForm = [];
  private dialogForm = {
    productName: "",
    productCode: "",
    productNo: "",
    defaultPremium: "",
    levelOnePremium: "",
    levelTwoPremium: "",
    levelThreePremium: "",
  };

  private loading = false;
  private isSaveLoading = false;
  private dialogFormVisible = false;
  private dialogRow = null;
  private searchFormParams = {};
  private templateUrl = "";
  private dialogFormType = 1;
  private selectedTableDatas = [];

  get orderListComputed() {
    return this.dataList;
  }
  get dialogFormTitle() {
    return this.dialogFormType === 1 ? "编辑" : "批量编辑";
  }

  get dialogFormRules() {
    const { validMeanNum } = this;
    // 数字正负号校验
    const propList = [
      "defaultPremium",
      "levelOnePremium",
      "levelTwoPremium",
      "levelThreePremium",
    ];
    const commonRule = [
      {
        required: true,
        validator: validMeanNum,
        trigger: "change",
      },
    ];
    let rulesObj = {};
    for (let item of propList) {
      rulesObj[item] = commonRule;
    }
    return rulesObj;
  }

  async handleTableRow(row) {
    this.dialogFormType = 1;
    this.dialogRow = row;
    this.resetLevelForm();
    if (row.k1Premiums && row.k1Premiums.length) {
      this.levelForm.forEach((v) => {
        let findObj = row.k1Premiums.find((k) => k.levelCode === v.levelCode);
        if (findObj && findObj.premium) {
          let num = findObj.premium;
          v.premium = num;
          if (parseInt(num) > 0) {
            v.premiumAdd = num;
            v.beyond = parseInt(num) > parseInt(row.premiumTop);
          } else {
            v.premiumLow = String(-num);
            v.beyond = parseInt(num) < parseInt(row.premiumFloor);
          }
        }
      });
    }
    this.dialogFormVisible = true;
  }
  resetLevelForm() {
    this.levelForm = this.levelForm.map((v) => ({
      levelName: v.levelName,
      levelCode: v.levelCode,
      premium: "",
      premiumLow: "",
      premiumAdd: "",
      beyond: false,
    }));
  }
  handleSelectionChange(vals) {
    this.selectedTableDatas = vals;
  }
  onBatchSet() {
    if (!this.selectedTableDatas.length) {
      this.$message.error("请先选择商品");
      return;
    }
    this.dialogFormType = 2;
    this.dialogRow = null;
    this.resetLevelForm();
    this.dialogFormVisible = true;
  }
  async handleDialogConfirm() {
    try {
      // type: 1（编辑）2（批量编辑）
      this.isSaveLoading = true;
      let list = [];
      let params = [];
      if (this.dialogFormType === 1) {
        console.log(this.dialogRow);
        list = [this.dialogRow];
      } else {
        list = this.selectedTableDatas;
      }
      list.forEach((v) => {
        params.push(
          ...this.levelForm.map((k) => ({
            productCode: v.productCode,
            levelCode: k.levelCode,
            premium: k.premium,
          })),
        );
      });
      await this.updateK1Premium({ K1Premium: params });
      this.$message.success("操作成功！");
      this.dialogFormVisible = false;
      this.getData();
      this.isSaveLoading = false;
    } catch (error) {
      this.isSaveLoading = false;
    }
  }
  isOaCooperation: any = "";
  async created() {
    this.isOaCooperation = localStorage.getItem("isOaCooperation");
    await this.getDicDatas();
  }
  async mounted() {
    this.loading = true;
    await this.getAttrApi();
    await this.getLevelList();
    await this.getData();
  }

  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum,
    };
    try {
      let { total, list } = await this.queryK1PremiumPage({
        input: { ...this.form, ...pageInput },
      });
      (this as any).total = total;
      this.dataList = list;
    } catch (err) {
      console.error(err);
      this.dataList = [];
      (this as any).total = 0;
    }
  }
  async getLevelList() {
    let data = await this.queryCustomerLevelList();
    this.levelList = data;
    this.levelForm = data.map((v) => ({
      levelName: v.levelName,
      levelCode: v.levelCode,
      premium: "",
      premiumLow: "",
      premiumAdd: "",
      beyond: false,
    }));
  }
  async getDicDatas() {
    this.$dd.register(["PRODUCT_STATUS"]).query();
    // this.getSystemVal();
  }
  async getAttrApi() {
    const res = await this.getPCRAttr({
      codeList: ["_specification", "_pattern"],
      orgCode: "default",
    });
    let specificationListOptions = (res && res[0] && res[0].value) || [];
    let patternListOptions = (res && res[1] && res[1].value) || [];
    this.specificationListOptions = specificationListOptions.map(
      ({ label, value }) => ({
        label: label,
        value: label,
      }),
    );
    this.patternListOptions = patternListOptions.map(({ label, value }) => ({
      label: label,
      value: label,
    }));
  }
  async exportExcelFn() {
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum,
    };
    return await this.exportK1Premium({
      input: { ...this.form, ...pageInput },
    });
  }
  async importMethod(File: any = {}) {
    const { name = "file" } = File.file;
    const { filePath = "" } = File;
    try {
      const {
        data: {
          api: { success = false, code },
        },
      } = await this.importK1Premium({
        url: filePath,
      });
      console.log(success, "res");
      if (success) {
        // this.$message.success("导入成功");
        const h = this.$createElement;
        this.notice = this.$message({
          type: "success",
          duration: 5000,
          showClose: true,
          customClass: "gt-export-dialog-message-wrap",
          message: h("div", { class: "gt-export-dialog-product-success" }, [
            h("p", null, "导入请求已经成功提交"),
            h(
              "p",
              {
                class: "gt-export-dialog-product-view",
                on: {
                  click: this.handleViewImport,
                },
              },
              "查看导入状态",
            ),
          ]),
        });
        (this as any).onResetBtnClick();
      } else {
        this.$message.error(code);
      }
    } catch (error) {
      console.log(error);
    }
  }
  async getSystemVal() {
    const { valueValue } = await this.getSystemValue({
      valueCode: "IMPORT_SET_PRICE_URL",
    });
    this.templateUrl = valueValue;
  }
  async getDownloadTemplate() {
    // if (this.templateUrl) {
    //   return;
    // }
    // const {
    //   data: {
    //     api: { code = "" }
    //   }
    // } = await this.downloadPremiumModel();
    // this.templateUrl = code;
  }
  // handleTabClick(val) {
  //   this.form.status = val;
  //   (this as any).onResetBtnClick();
  //   this.getData();
  // }
  resetDialogForm() {
    this.$nextTick(() => {
      (this.$refs.dialogFormRef as any).clearValidate();
    });
  }
  fAttrValueName(row, item) {
    try {
      const findObj = row.k1Premiums.find(
        (v) => v.levelCode === item.levelCode,
      );
      if (findObj && findObj["premium"]) {
        let num = findObj["premium"];
        return parseInt(num) === 0 ? "0" : parseInt(num);
      } else {
        return "0";
      }
    } catch (error) {
      return "0";
    }
  }
  getBeyond(row, item) {
    try {
      let findObj = row.k1Premiums.find((v) => v.levelCode === item.levelCode);
      let premium = "0";
      if (findObj && findObj["premium"]) {
        let num = findObj["premium"];
        premium = parseInt(num) === 0 ? "0" : num;
      }
      if (row.premiumTop && row.premiumFloor) {
        if (
          parseInt(premium) > parseInt(row.premiumTop) ||
          parseInt(premium) < parseInt(row.premiumFloor)
        ) {
          return true;
        }
      } else if (row.premiumTop) {
        if (parseInt(premium) > parseInt(row.premiumTop)) {
          return true;
        }
      } else if (row.premiumFloor) {
        if (parseInt(premium) < parseInt(row.premiumFloor)) {
          return true;
        }
      }
      return false;
    } catch (error) {
      return false;
    }
  }
  changePremiumLow(item, index) {
    let value = item.premiumLow ? "-" + item.premiumLow : "";
    this.levelForm[index]["premium"] = value;
    this.levelForm[index]["beyond"] = false;
    const dialogRow = this.dialogRow;
    if (dialogRow && dialogRow.premiumFloor) {
      this.levelForm[index]["beyond"] =
        parseInt(value) < parseInt(dialogRow.premiumFloor);
    }
  }
  changePremiumAdd(item, index) {
    let value = item.premiumAdd;
    this.levelForm[index]["premium"] = value;
    this.levelForm[index]["beyond"] = false;
    const dialogRow = this.dialogRow;
    if (dialogRow && dialogRow.premiumTop) {
      this.levelForm[index]["beyond"] =
        parseInt(value) > parseInt(dialogRow.premiumTop);
    }
  }
  validMeanNum = (rule, value, callback) => {
    if (Number(value) === 0) {
      callback();
      return;
    }
    // 不包含正负号的数字
    const isMoneyNum = moneyRegexp.test(String(Math.abs(value)));
    // 只有正负号可以通过
    const isSign = !isNaN(parseFloat(value));
    if (isMoneyNum && isSign) {
      callback();
    } else {
      callback(new Error("溢价金额仅支持负数、0和正数，最多支持2位小数"));
    }
  };
  routeParams: any = "2";
  notice: any = "";
  handleViewImport() {
    this.notice && this.notice.close();

    let menuMap: any = JSON.parse(localStorage.getItem("menuListMap") || "{}");
    let ygjExportPath: any = "/app/k-one-frontend/import";
    let appCode = (window as any).__GTECH_VARIABLES_APP_CODE__;

    if (menuMap[ygjExportPath]) {
      // "K-ONE", "WIN-TOGETHER-TBR"
      if (appCode === "WIN-TOGETHER-TBR" && this.mainRouter) {
        let routeUrl = this.mainRouter.resolve({
          path: ygjExportPath,
          query: { importParams: String(this.routeParams || "") }
        });
        window.open(routeUrl.href, "_blank");
        return;
      }
      if (["WIN-TOGETHER", "WIN-TOGETHER-CN"].includes(appCode)) {
        let routeUrl = this.$router.resolve({
          path: ygjExportPath,
          query: { importParams: String(this.routeParams || "") }
        });
        window.open(routeUrl.href, "_blank");
        return;
      }
    }

    let routeUrl = this.$router.resolve({
      path: "/import",
      query: { importParams: String(this.routeParams || "") }
    });
    window.open(routeUrl.href, "_blank");
  }
  destroyed() {
    this.notice && this.notice.close();
  }
}
